import { useEffect, useState } from "react"
import { View } from "../../state/listing/generic-listing"
import { TaxService } from "../../state/tax/service"
import { COLUMNS_WITH_TAX_IDS, doesViewIncludeIds } from "../listing/generic-listing/utils"
import { SelectOption } from "../types"

export const useFetchTaxes = (view: View, controller: AbortController) => {
    const [taxOptions, setTaxOptions] = useState<SelectOption<string>[]>()
    const [loadingTaxOptions, setLoadingTaxOptions] = useState<boolean>(false)

    useEffect(() => {
        const shouldFetchTaxes = view && !taxOptions && doesViewIncludeIds(view, COLUMNS_WITH_TAX_IDS)

        if (shouldFetchTaxes) {
            setLoadingTaxOptions(true)

            new Promise<SelectOption<string>[]>((resolve, reject) => {
                TaxService.getAsSelectOptions().then(resolve)
                controller.signal.addEventListener("abort", () => reject(new Error("taxes request aborted")))
            }).then(taxOptions => {
                setTaxOptions(taxOptions)
                setLoadingTaxOptions(false)
            }).catch(err => console.warn(err))
        }
    }, [view])

    return {
        taxOptions,
        loadingTaxOptions,
    }
}


// WEBPACK FOOTER //
// ./src/common/hooks/UseFetchTaxes.tsx